/**
 * Where an in-progress sign-out is heading. Firebase clears the user before AuthProvider navigates,
 * so route guards read this to go straight to the intended login URL instead of remembering the
 * page being left (which would otherwise produce /login?next=... after a deliberate sign-out).
 */
export const signOutTarget: { current: string | null } = { current: null };
